import { render, staticRenderFns } from "./chuzhijilu.vue?vue&type=template&id=18d8fdf1&scoped=true"
import script from "./chuzhijilu.vue?vue&type=script&lang=js"
export * from "./chuzhijilu.vue?vue&type=script&lang=js"
import style0 from "./chuzhijilu.vue?vue&type=style&index=0&id=18d8fdf1&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18d8fdf1",
  null
  
)

export default component.exports